var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/overview/Pickup-Details") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295 C60,13.727 46.569,0.295 30,0.295 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.295 C13.432,0.295 0,13.727 0,30.295 L0,30.295 C0,46.863 13.432,60.294 30,60.294 L30,60.294 C46.569,60.294 60,46.863 60,30.295 L60,30.295",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-23",
    points: "0 0.295 60 0.295 60 60.2949 0 60.2949"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "States-&-Styles-&-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets---Icons",
    transform: "translate(-176.000000, -476.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/overview/pickup-details",
    transform: "translate(176.000000, 476.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(0.000000, 0.705100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1035,69.9999 C22.2715,69.9999 20.6755,68.7629 20.2215,66.9929 L10.3435,28.4149 C10.0805,27.3849 10.2355,26.3099 10.7825,25.3879 C11.3295,24.4649 12.1975,23.8119 13.2265,23.5479 L42.5595,16.0369 C42.8825,15.9539 43.2135,15.9119 43.5445,15.9119 C45.3765,15.9119 46.9735,17.1479 47.4265,18.9189 L57.3055,57.4969 C57.8525,59.6339 56.5595,61.8169 54.4225,62.3639 L25.0885,69.8749 C24.7655,69.9579 24.4345,69.9999 24.1035,69.9999",
    id: "Fill-1",
    fill: "#444B68",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5449,14.912 C43.1379,14.912 42.7239,14.962 42.3119,15.068 L12.9789,22.579 C10.3149,23.261 8.6919,25.999 9.3749,28.663 L19.2529,67.241 C19.8299,69.493 21.8759,71 24.1049,71 C24.5119,71 24.9249,70.95 25.3369,70.844 L54.6709,63.333 C57.3349,62.651 58.9559,59.913 58.2739,57.249 L48.3959,18.671 C47.8189,16.419 45.7739,14.912 43.5449,14.912 M43.5449,16.912 C44.9199,16.912 46.1179,17.839 46.4579,19.167 L56.3369,57.745 C56.7469,59.348 55.7769,60.985 54.1749,61.395 L24.8409,68.907 C24.5989,68.969 24.3519,69 24.1049,69 C22.7289,69 21.5299,68.073 21.1909,66.745 L11.3129,28.167 C10.9009,26.564 11.8719,24.927 13.4749,24.516 L42.8079,17.005 C43.0499,16.943 43.2979,16.912 43.5449,16.912",
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "50.8164 56.3198 24.9964 62.8448 16.2924 28.4008 42.1114 21.8748"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9043,16.3085 C27.7693,16.3085 27.6343,16.3255 27.5033,16.3595 C27.0863,16.4665 26.7353,16.7285 26.5163,17.0985 C26.2973,17.4675 26.2353,17.9005 26.3423,18.3165 C26.5243,19.0305 27.1663,19.5295 27.9023,19.5295 C28.0363,19.5295 28.1713,19.5125 28.3013,19.4785 C29.1623,19.2585 29.6823,18.3785 29.4623,17.5185 C29.2793,16.8065 28.6383,16.3085 27.9043,16.3085 M21.5143,30.8945 C20.5263,30.8945 19.6833,30.0485 19.5103,28.8835 C19.4793,28.7025 18.7743,24.2825 22.9673,20.9165 C22.6713,20.4305 22.4493,19.9055 22.3063,19.3505 C21.5163,16.2665 23.3833,13.1145 26.4693,12.3235 C26.9403,12.2035 27.4233,12.1415 27.9053,12.1415 C30.5433,12.1415 32.8413,13.9285 33.4963,16.4855 C33.6373,17.0365 33.6953,17.6035 33.6693,18.1765 C38.9643,19.1125 40.4693,23.3275 40.5333,23.5115 C40.7843,24.1905 40.7583,24.9135 40.4593,25.4835 C40.2173,25.9425 39.8173,26.2645 39.3313,26.3885 L21.9483,30.8395 C21.8053,30.8755 21.6603,30.8945 21.5143,30.8945",
    id: "Fill-10",
    fill: "#444B68",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9014,19.0292 C27.3944,19.0292 26.9524,18.6852 26.8264,18.1922 C26.6744,17.6002 27.0344,16.9952 27.6274,16.8432 C27.7174,16.8202 27.8114,16.8082 27.9034,16.8082 C28.4104,16.8082 28.8514,17.1512 28.9774,17.6422 C29.0504,17.9292 29.0074,18.2282 28.8564,18.4842 C28.7064,18.7392 28.4644,18.9202 28.1774,18.9942 C28.0874,19.0172 27.9944,19.0292 27.9014,19.0292 M27.9054,11.6422 C27.3814,11.6422 26.8564,11.7082 26.3454,11.8392 C24.7214,12.2552 23.3574,13.2792 22.5034,14.7202 C21.6484,16.1632 21.4064,17.8512 21.8224,19.4742 C21.9404,19.9362 22.1104,20.3792 22.3284,20.8002 C18.2714,24.3112 18.9854,28.7802 19.0194,28.9792 C19.2254,30.3692 20.2774,31.3942 21.5154,31.3942 C21.7024,31.3942 21.8894,31.3702 22.0724,31.3232 L39.4554,26.8732 C40.0804,26.7132 40.5934,26.3012 40.9014,25.7162 C41.2664,25.0202 41.3014,24.1502 40.9984,23.3282 C40.9404,23.1572 39.4174,18.8952 34.1734,17.7662 C34.1634,17.2912 34.0984,16.8212 33.9804,16.3612 C33.2704,13.5832 30.7714,11.6422 27.9054,11.6422 M27.9014,20.0292 C28.0744,20.0292 28.2504,20.0082 28.4254,19.9632 C29.5534,19.6742 30.2354,18.5232 29.9464,17.3942 C29.7024,16.4412 28.8434,15.8082 27.9034,15.8082 C27.7304,15.8082 27.5544,15.8302 27.3794,15.8752 C26.2504,16.1642 25.5684,17.3122 25.8574,18.4402 C26.1014,19.3942 26.9604,20.0292 27.9014,20.0292 M27.9054,12.6422 C30.2564,12.6422 32.4024,14.2272 33.0114,16.6092 C33.1834,17.2792 33.2134,17.9512 33.1304,18.5992 C38.5674,19.3272 40.0604,23.6742 40.0604,23.6742 C40.4334,24.6862 40.0494,25.6882 39.2074,25.9042 L21.8244,30.3552 C21.7204,30.3822 21.6174,30.3942 21.5154,30.3942 C20.7904,30.3942 20.1434,29.7452 20.0054,28.8102 C20.0054,28.8102 19.2244,24.2802 23.6434,21.0282 C23.2574,20.5012 22.9634,19.8972 22.7914,19.2262 C22.0684,16.4052 23.7714,13.5312 26.5934,12.8082 C27.0324,12.6962 27.4714,12.6422 27.9054,12.6422",
    id: "Fill-13",
    fill: "#FFFFFF",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6484,34.0341 L40.1274,32.1191",
    id: "Stroke-16",
    stroke: "#444B68",
    strokeWidth: 2,
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-19",
    stroke: "#444B68",
    strokeWidth: 2,
    mask: "url(#mask-14)",
    points: "23.6689 37.5532 26.0319 39.2772 29.4079 33.5882"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4639,46.7768 L42.9429,44.8618",
    id: "Stroke-22",
    stroke: "#444B68",
    strokeWidth: 2,
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-25",
    stroke: "#444B68",
    strokeWidth: 2,
    mask: "url(#mask-18)",
    points: "26.4238 50.3115 28.7868 52.0355 32.1628 46.3455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6211,37.041 L41.1001,35.126",
    id: "Stroke-28",
    stroke: "#444B68",
    strokeWidth: 2,
    mask: "url(#mask-20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-33"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4365,49.7836 L43.9155,47.8686",
    id: "Stroke-31",
    stroke: "#444B68",
    strokeWidth: 2,
    mask: "url(#mask-22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(0.000000, 0.705100)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.2949 C13.432,0.2949 0,13.7269 0,30.2949 C0,46.8629 13.432,60.2949 30,60.2949 C46.568,60.2949 60,46.8629 60,30.2949 C60,13.7269 46.568,0.2949 30,0.2949 M30,2.2949 C45.439,2.2949 58,14.8559 58,30.2949 C58,45.7339 45.439,58.2949 30,58.2949 C14.561,58.2949 2,45.7339 2,30.2949 C2,14.8559 14.561,2.2949 30,2.2949",
    id: "Fill-35",
    fill: "#444B68",
    mask: "url(#mask-24)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.cfb0a4530380f7bc53f3e1c3ac88d606.svg";
export { ForwardRef as ReactComponent };